String.prototype.toFirstCharTitleCase = function() {
	return this.charAt(0).toLocaleUpperCase() + this.slice(1);
}

String.prototype.toTitleCase = function() {
	return this.replace(/[\u0041-\u005A\u0061-\u007A\u00C0-\u00FF]+/g, function(token){ return token.toFirstCharTitleCase(); });
}

String.prototype.replaceDiacritics = function() {
	var res = this.replace();
	
	var diacritics =[
		/[\300-\306]/g, /[\340-\346]/g, // A, a
		/[\310-\313]/g, /[\350-\353]/g, // E, e
		/[\314-\317]/g, /[\354-\357]/g, // I, i
		/[\322-\330]/g, /[\362-\370]/g, // O, o
		/[\331-\334]/g, /[\371-\374]/g,  // U, u
		/[\321]/g, /[\361]/g, // N, n
		/[\307]/g, /[\347]/g, // C, c
	];

	var chars = ['A','a','E','e','I','i','O','o','U','u','N','n','C','c'];

	for (var i = 0; i < diacritics.length; i++)
	{
		res = res.replace(diacritics[i],chars[i]);
	}

	return res;
}
